"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.position = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/

const pageId = exports.pageId = 174761410197;
const slug = exports.slug = 'guides/cms/react/modules';
const title = exports.title = 'Modules';
const name = exports.name = 'Modules';
const metaDescription = exports.metaDescription = 'Learn more about CMS React modules, including how to structure your files and use fields.';
const position = exports.position = 5;
const navTitle = exports.navTitle = 'Modules';
const toc = exports.toc = [{
  "depth": 0,
  "id": "directory-structure",
  "label": "Directory structure",
  "parent": null
}, {
  "depth": 0,
  "id": "module-fields",
  "label": "Module fields",
  "parent": null
}, {
  "depth": 1,
  "id": "building-fields-with-jsx",
  "label": "Building fields with JSX",
  "parent": "module-fields"
}, {
  "depth": 1,
  "id": "repeated-field-groups",
  "label": "Repeated field groups",
  "parent": "module-fields"
}, {
  "depth": 1,
  "id": "using-field-values",
  "label": "Using field values",
  "parent": "module-fields"
}, {
  "depth": 0,
  "id": "graphql",
  "label": "GraphQL",
  "parent": null
}, {
  "depth": 0,
  "id": "passing-hubl-data",
  "label": "Passing HubL data",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      code: "code",
      pre: "pre",
      ul: "ul",
      li: "li",
      h3: "h3"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      RelatedApiLink
    } = _components;
  if (!RelatedApiLink) _missingMdxReference("RelatedApiLink", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Creating CMS React modules"
    }), "\n", (0, _jsxRuntime.jsx)(RelatedApiLink, {}), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["CMS React modules are similar to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/modules/overview",
        children: "traditional HubL modules"
      }), ", in that they have fields, can be edited in the content editor, and can be used in ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/drag-and-drop/overview",
        children: "drag and drop areas"
      }), ". But the HTML for a React module is generated by a React component instead of HubL, and its fields can be generated with either JSX or JSON."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Below, learn more about building CMS React modules, including required directory structure, defining fields, and working with data."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Directory structure"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["CMS React modules must be located in the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/components/modules"
      }), " subdirectory of your ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/react/project-structure",
        children: "CMS React project"
      }), ". The JavaScript file can either live within that directory or be contained within another directory, using the module name as the file/directory name."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "/components/modules/ExampleModule/index.jsx"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "js-package/\n└── components/\n    └── modules/\n        └── ExampleModule/\n            └── index.jsx\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "/components/modules/ExampleModule.jsx"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "js-package/\n└── components/\n    └── modules/\n        └── ExampleModule.jsx\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The path will determine how you reference the module in HubL, as shown below."
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "// ExampleModule/index.jsx\n{% module \"ExampleModule\"\n  path=\"@projects/your-project/js-package/components/modules/ExampleModule\",\n%}\n\n// ExampleModule.jsx\n{% module \"ExampleModule\"\n  path=\"@projects/your-project/js-package/components/modules/ExampleModule.jsx\",\n%}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Whichever path you choose, the file (i.e., either ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ExampleModule/index.jsx"
      }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ExampleModule.jsx"
      }), ") must contain the following named exports:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "Component"
        }), ": a React component to be rendered. It may contain ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/react/islands",
          children: "islands"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "meta"
        }), ": a JavaScript object, equivalent to the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "meta.json"
        }), " file in HubL modules."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "fields"
        }), ": a JSX tree using components from ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "@hubspot/cms-components/fields"
        }), " to define module fields or a traditional JavaScript fields object."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "// Directory Structure for module-as-directory\njs-package/\n└── components/\n    └── modules/\n        └── ExampleModule/\n            ├── ExampleModuleFields.jsx\n            ├── ExampleModuleComponent.jsx\n            ├── ExampleModuleMeta.js\n            └── index.jsx\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["As an example, your ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "index.jsx"
      }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ExampleModule.jsx"
      }), " file exports might look similar to the following:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "import { ModuleFields, TextField } from '@hubspot/cms-components/fields';\nimport footerStyles from '../../../styles/footer.module.css';\n\nexport function Component({ fieldValues }: any) {\n  return (\n    <footer className={footerStyles.footer}>\n      <p>{fieldValues.footerText}</p>\n    </footer>\n  );\n}\n\nexport const fields = (\n  <ModuleFields>\n    <TextField label=\"Footer Text\" name=\"footerText\" default=\"Be Well.\" />\n  </ModuleFields>\n);\n\nexport const meta = {\n  label: 'Footer Module',\n};\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Note that you may use re-exports, as shown in the example ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "index.jsx"
      }), " file below:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "/* Note: index.js re-exports\nExampleModuleFields.jsx,\nExampleModuleMeta.js,\nand ExampleModuleComponent.jsx\nas named exports\n */\nexport { default as Component } from './ExampleModuleComponent.jsx';\nexport { fields } from './ExampleModuleFields.jsx';\nexport { meta } from './ExampleModuleMeta.js';\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Module fields"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Module fields can be expressed as a JSX tree using field components from ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "@hubspot/cms-components/fields"
      }), ". These are the same ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/fields/module-theme-fields",
        children: "module fields"
      }), " that HubL modules use. TypeScript definitions are included so that you can benefit from autocomplete and validation when defining fields. You can find all available fields in the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/fields/module-theme-fields",
        children: "fields reference documentation"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You may express field definitions as an array of JavaScript objects identical to the traditional HubL module ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/fields/module-theme-fields",
        children: "JSON structure"
      }), ", exporting the same way as ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "fields"
      }), ". However, using JSX syntax is recommended, as it comes with the benefits of improved readability, sharing field logic, and more."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Building fields with JSX"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "By writing module fields using JSX, you'll benefit from improved readability, along with the ability to dynamically generate fields, share field logic between modules, and create custom abstractions around field definitions."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, below is a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "FullNameField"
      }), " custom field component that abstracts out a group of two or three text fields:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "import {\n  ModuleFields,\n  TextField,\n  FieldGroup,\n  BooleanField\n} from '@hubspot/cms-components/fields';\n\nconst FullNameField = ({ includeMiddleName = false }) => (\n  <FieldGroup\n    name=\"full_name\"\n    label=\"Full Name\"\n>\n    <TextField\n      name=\"given_name\"\n      label=\"Given Name\"\n      default=\"HubSpot\"\n      required={true}\n    />\n    {includeMiddleName && (\n      <TextField\n        name=\"middle_name\"\n        label=\"Middle Name\"\n        default=\"\"\n      />\n    )}\n    <TextField\n      name=\"family_name\"\n      label=\"Family Name\"\n      default=\"Developer\"\n    />\n  </FieldGroup>\n);\n\n\nexport const fields = (\n  <ModuleFields>\n    <TextField\n      name=\"example_field\"\n      label=\"Example Text Field\"\n      default=\"Placeholder text\" />\n\n    <FieldGroup name=\"group_of_fields\" label=\"Field Group\">\n      <BooleanField\n        name=\"child_boolean_field\"\n        label=\"Child Boolean Field\"\n        default={true}\n      />\n      <TextField\n        name=\"child_text_field\"\n        label=\"Child Text Field\"\n        default=\"Child Field\"\n      />\n    </FieldGroup>\n\n\n    {/*Using the custom field component alongside other fields*/}\n    <FullNameField includeMiddleName={false}>\n  </ModuleFields>\n);\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Note that the root component of the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "fields"
      }), " export must be ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ModuleFields"
      }), ". Additionally, the above code makes use of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "FieldGroup"
      }), ", which is the component type that creates the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/fields/overview#field-groups",
        children: "field groups"
      }), " you would use in HubL modules."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "FullNameField"
      }), " React component for the module fields defined above, props will have the following shape:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "// FullNameField module field props\n{\n  example_field: \"Placeholder text\",\n  group_of_fields: {\n    child_boolean_field: true,\n    child_text_field: \"Child Field\"\n  },\n  full_name: {\n    given_name: \"HubSpot\",\n    family_name: \"Developer\",\n  }\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Note that the default was used to fill in the value field once it was passed. This is because module values are passed from the server, so if someone changes the value of a field in the page editor, the new value will be passed to your module. But in the above case where no page-level field value is set, the server passes the default value to your props."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Repeated field groups"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In addition to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ModuleFields"
      }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "FieldGroup"
      }), ", another component type from ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "@hubspot/cms-components/fields"
      }), " is ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "RepeatedFieldGroup"
      }), ". It creates a field group repeater, and can be used as shown below:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "export const fields = (\n  <ModuleFields>\n    <RepeatedFieldGroup\n      name=\"default_todos\"\n      label=\"Default Todos\"\n      occurrence={{\n        min: 1,\n        max: 500,\n        default: 1,\n      }}\n      default={[\n        {\n          text: 'Todo Test 1a',\n          completed: false,\n        },\n        {\n          text: 'Todo Test 2',\n          completed: true,\n        },\n      ]}\n    >\n      <TextField label=\"Todo title\" name=\"text\" default=\"Todo...\" required />\n      <BooleanField label=\"Todo Completed\" name=\"completed\" default={false} />\n    </RepeatedFieldGroup>\n  </ModuleFields>\n);\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Using field values"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Field values are passed as props to the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "Component"
      }), " export of the module. For example, the code below would use the field structure from the previous example inside your module's component:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "export const Component = ({ fieldValues }) => {\n  return (\n    <ul>\n      <li>{fieldValues.example_field}</li>\n      <li>{fieldValues.group_of_fields.child_text_field}</li>\n    </ul>\n  );\n};\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "GraphQL"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Like in HubL modules, you can ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/data-driven-content/graphql/query-hubspot-data-using-graphql",
        children: "bind a GraphQL data query"
      }), " to a React module to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/react/data-fetching",
        children: "fetch data"
      }), ". The GraphQL integration currently supports querying data from HubDB and custom objects."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Adding a named ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "query"
      }), " export to a module will provide the query result to render in the component props as ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "dataQueryResult"
      }), ". You can import and re-export a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".graphql"
      }), " query file or a JavaScript expression that evaluates to a GraphQL query (e.g., with ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://www.npmjs.com/package/gql-query-builder",
        children: "gql-query-builder"
      }), ")."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "// index.js\n\nimport ModuleComponent from './ModuleComponent.js';\nimport ModuleFields from './ModuleFields.js';\nimport ModuleMeta from './ModuleMeta.js';\nimport myQuery from './myQuery.graphql';\n\n// This component will receive the query result via `dataQueryResult`\nexport const Component = ModuleComponent;\n\nexport const meta = ModuleMeta;\n\nexport const fields = ModuleFields;\n\nexport const query = myQuery;\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Accessing the data in ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ModuleComponent"
      }), " is shown below:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "//ModuleComponent.jsx\n\nexport default function ModuleComponent(props) {\n  return (\n    <div>\n      <span>\n        {props.dataQueryResult.data.CRM.contact_collection.items[0].firstname}\n      </span>\n      <span>\n        {props.dataQueryResult.data.CRM.contact_collection.items[0].lastname}\n      </span>\n    </div>\n  );\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Using GraphQL in this way will connect any module and subsequent downstream pages to updates to the query and upstream data. Updates to data sources referenced from the query will cause the page to prerender. Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/react/data-fetching",
        children: "fetching data"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To explore your account's GraphQL schema and build queries, you can use the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "http://app.hubspot.com/l/graphiql",
        children: "GraphiQL"
      }), " tool in your account. Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/data-driven-content/graphql/query-hubspot-data-using-graphql#test-and-run-queries-interactively-using-graphiql",
        children: "testing and running queries using GraphiQL"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Passing HubL data"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To automatically attach and pass through HubL context variables to your React modules, you can use the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hublDataTemplate"
      }), " API."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["First, export a string from your module via ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hublDataTemplate"
      }), ". In that string, set the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hublData"
      }), " variable."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "export const hublDataTemplate = `{% set hublData = \"Hello from HubL!\" %}`;\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The template will accept any valid HubL, including ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/hubl/filters",
        children: "filters"
      }), " and ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/hubl/functions",
        children: "functions"
      }), " and ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/fields/module-theme-fields",
        children: "module field references"
      }), ". The data will come through on your React module as a top level prop of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hublData"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "import ModuleFields from './ModuleFields.js';\nimport ModuleMeta from './ModuleMeta.js';\n\nexport function Component(props) {\n  return (\n    <div>\n      <div>My total posts: {props.hublData.totalBlogPostCount}</div>\n      <a href={props.hublData.blogAllPostsUrl}>View all posts</a>\n    </div>\n  );\n}\n\nexport const meta = ModuleMeta;\n\nexport const fields = ModuleFields;\n\nexport const hublDataTemplate = `\n  {% set blogId = module.blog_field %}\n  {% set hublData = {\n      \"totalBlogPostCount\": blog_total_post_count(blogId),\n      \"blogAllPostsUrl\": blog_all_posts_url(blogId)\n    }\n  %}\n`;\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["While developing modules in ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "cms-dev-server"
      }), ", update the URL to include ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/preview/"
      }), " between the port number of your locally running server and the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/module/..."
      }), " routes to have your local ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hublDataTemplate"
      }), " string resolve."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hslocal.net:3000/preview/module/..."
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}